import React, { useState, useEffect } from 'react';

const Standings = () => {
  const [standings, setStandings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // API base URL from environment variables
  
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // Map numeric group IDs to letters (1 => A, 2 => B, etc.)
  const groupIdToLetter = (id) => {
    return String.fromCharCode(64 + parseInt(id)); // 65 is 'A' in ASCII
  };

  // Fetch standings data from API
  useEffect(() => {
    const fetchStandings = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/standings`);

        if (!response.ok) {
          throw new Error(`Failed to load standings: ${response.status}`);
        }

        const data = await response.json();
        setStandings(data);
      } catch (err) {
        setError(err.message);
        console.error('Standings fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStandings();

    const intervalId = setInterval(() => {
      fetchStandings();
    }, 300000); // Refresh standings every 5 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount 

  }, []);

  

  // Render loading state
  if (loading) {
    return (
      <div className="standings-page main-content">
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading standings...</p>
        </div>
      </div>
    );
  }

  // Render error state
  if (error) {
    return (
      <div className="standings-page main-content">
        <div className="error-container">
          <h2>Error Loading Standings</h2>
          <p>{error}</p>
          <p>Please try again later or contact support.</p>
        </div>
      </div>
    );
  }

  // Render standings tables
  return (
    <div className="standings-page main-content">
      <div className="tables-container">
        {Object.keys(standings).map(groupId => {
          // Convert numeric group ID to letter (1 => A, 2 => B, etc.)
          const groupLetter = groupIdToLetter(groupId);

          return (
            <div key={groupId} className="table-wrapper">
              <div className="group-header">
                <h2>{groupLetter} csoport</h2>
              </div>

              <table className="styled-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Csapat</th>
                    <th>MP</th>
                    <th>W</th>
                    <th>D</th>
                    <th>L</th>
                    <th>G</th>
                    <th>GD</th>
                    <th>PTS</th>
                  </tr>
                </thead>
                <tbody>
                  {standings[groupId].map((team, index) => {
                    // Calculate match played
                    const matchesPlayed = parseInt(team.wins) + parseInt(team.draws) + parseInt(team.losses);



                    return (
                      <tr key={`${groupId}-${index}`}>
                        <td className="position">{team.place}.</td>
                        <td className="team-name">
                          <div className="team-name-container">
                            <div className="flag-placeholder"></div>
                            <span>{team.team}</span>
                          </div>
                        </td>
                        <td>{matchesPlayed}</td>
                        <td>{team.wins}</td>
                        <td>{team.draws}</td>
                        <td>{team.losses}</td>
                        <td>{team.goals}</td>
                        <td className={team.goalDifference > 0 ? 'positive' : team.goalDifference < 0 ? 'negative' : ''}>
                          {team.goalDifference > 0 ? `+${team.goalDifference}` : team.goalDifference}
                        </td>
                        <td className="points">{team.points}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Standings;